export const enrichInvitationsWithCheckIns = (event) => {
  if (!event || !event.invitations) return event;

  const checkedInMap = new Map();

  if (Array.isArray(event.checkIns)) {
    event.checkIns.forEach((checkIn) => {
      if (Array.isArray(checkIn.checkedInGuests)) {
        checkIn.checkedInGuests.forEach((checkedGuest) => {
          if (checkedGuest.checkInStatus === true) {
            const guestId =
              checkedGuest.guestId && typeof checkedGuest.guestId === "object"
                ? checkedGuest.guestId._id || checkedGuest.guestId.$oid
                : checkedGuest.guestId;

            checkedInMap.set(guestId, {
              isCheckedIn: true,
              checkInTime: checkedGuest.checkInTime,
              viaQRCode: checkedGuest.viaQRCode,
            });
          }
        });
      }
    });
  }

  const enrichedInvitations = event.invitations.map((invitation) => {
    const guestId =
      invitation.guestId && typeof invitation.guestId === "object"
        ? invitation.guestId._id
        : invitation.guestId;

    const checkInData = checkedInMap.get(guestId);

    return {
      ...invitation,
      isCheckedIn: checkInData?.isCheckedIn || false,
      checkInTime: checkInData?.checkInTime || null,
      viaQRCode: checkInData?.viaQRCode || false,
    };
  });

  return {
    ...event,
    invitations: enrichedInvitations,
  };
};
